export function loadScript(src = '', isForceReload = false) {
    return new Promise(function(resolve, reject) {
        // 这里有隐藏问题，已经存在的标签，但不一定就证明已经成功加载
        if (window.document.querySelector(`script[src="${src}"]`) && !isForceReload) {
            resolve();
        } else {
            const el = window.document.createElement('script');

            el.type = 'text/javascript';
            el.async = true;
            el.src = src;

            el.addEventListener('load', resolve);
            el.addEventListener('error', reject);
            el.addEventListener('abort', reject);

            window.document.head.appendChild(el);
        }
    });
}

export function getCrtUrl(win = {}) {
    return `${win.location.protocol}//${win.location.host}${win.location.pathname}${win.location.search}`;
}

export function buildURL() {
}

export function isXCAccount(val) {
    return /^xc[0-9]{5}$/i.test(val);
}
